import { render, staticRenderFns } from "./case-storage.vue?vue&type=template&id=8ee61fd0&"
import script from "./case-storage.vue?vue&type=script&lang=js&"
export * from "./case-storage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports